import { render, staticRenderFns } from "./Atalho.vue?vue&type=template&id=675ba952&scoped=true&lang=pug"
import script from "./Atalho.vue?vue&type=script&lang=js"
export * from "./Atalho.vue?vue&type=script&lang=js"
import style0 from "./Atalho.vue?vue&type=style&index=0&id=675ba952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ba952",
  null
  
)

export default component.exports